define('viewmodels/pages/cash/methods/boku/UseBokuDepositViewModel',[],function () {

    function UseBokuDepositViewModel(BokuDepositAmountStep, depositModel, Wizard) {

        this.wizardModel = new Wizard({
            steps: [
                new BokuDepositAmountStep(depositModel)
            ]
        });
    }

    UseBokuDepositViewModel.prototype.getView = function () {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return UseBokuDepositViewModel;
});


